import { Button, Grid, Popover, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from '@mui/material';
import _ from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setHelperText, setShowHelperTextModal, setTitle } from './reducers/SupportSheetHelpTextReducer';
import './SupportSheetHelpText.scss';

interface SupportSheetHelpTextProp {
    helpText: string,
    title?: string,
    className?: string,
}

const SupportSheetHelpText: React.FunctionComponent<SupportSheetHelpTextProp> = (props) => {
    const dispatch = useDispatch();
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

    return (
        <>
            <span
                className='support-sheet-help-text'
                onClick={() => {
                    dispatch(setTitle(props.title ? props.title : ""));
                    dispatch(setHelperText(props.helpText));
                    dispatch(setShowHelperTextModal(true));
                }}
            >
                <i className="fa fa-question-circle-o" aria-hidden="true"></i>
            </span>
        </>
    )
};

export default SupportSheetHelpText;